import React from 'react';

import { ProfileClientView } from '../components/ProfileClientView/ProfileClientView';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type TalentProfileClientViewPageProps = {
  name?: string;
};

export const TalentProfileClientViewPage = ({
  name = 'PROFILE_CLIENT_VIEW_PAGE',
}: TalentProfileClientViewPageProps) => {
  useDocumentTitle('Talent Profile');
  return (
    <div data-test={name}>
      <ProfileClientView />
    </div>
  );
};
